module.exports = __webpack_public_path__ + "static/Jolt-f79ef3b273d0439ccb59a78b9d47c663.jpg";